import { Link } from "react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Key, ArrowRight, BookOpen } from "lucide-react";

const quickStartCode = `# No dependencies, just curl
curl -H "Authorization: Bearer td_YOUR_KEY" \\
  https://travelapi.dev/v1/airports/JFK

# Climate normals for a city
curl -H "Authorization: Bearer td_YOUR_KEY" \\
  https://travelapi.dev/v1/weather/normals/2950159

# Transit departures from Alexanderplatz
curl -H "Authorization: Bearer td_YOUR_KEY" \\
  "https://travelapi.dev/v1/transit/stops/de:11000:900100003/departures?date=2026-05-18&time=14:30"

# JavaScript / TypeScript
const res = await fetch("https://travelapi.dev/v1/airports/JFK", {
  headers: { Authorization: "Bearer td_YOUR_KEY" }
});
const airport = await res.json();
console.log(airport.city); // "New York"`;

const DashboardPage = () => {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Dashboard</h1>
        <p className="text-muted-foreground mt-1">Manage your Travel API account</p>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Card>
          <CardHeader>
            <Key className="h-5 w-5 text-muted-foreground" />
            <CardTitle className="text-lg">API Keys</CardTitle>
            <CardDescription>Create and manage your API keys</CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" size="sm" asChild>
              <Link to="/keys">
                Manage Keys
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <BookOpen className="h-5 w-5 text-muted-foreground" />
            <CardTitle className="text-lg">API Documentation</CardTitle>
            <CardDescription>Explore endpoints and integration guides</CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" size="sm" asChild>
              <Link to="/docs">
                View Docs
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>

      {/* Quick Start */}
      <Card>
        <CardHeader>
          <CardTitle>Quick Start</CardTitle>
          <CardDescription>
            Get started with the Travel API in seconds
          </CardDescription>
        </CardHeader>
        <CardContent>
          <pre className="bg-muted rounded-lg p-4 overflow-x-auto text-sm">
            <code>{quickStartCode}</code>
          </pre>
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardPage;
